/* -------------------------------------------------------------------
  stickyContent
------------------------------------------------------------------- */

const stickyContent = (targetClass = [], scroll = 300) => {
  window.onscroll = () => {
    targetClass.forEach((target, i)=> {
      const el         = document.querySelector('.' + target[0])
      const classReady = 'scroll-ready'
      const classFixed = 'scroll-on'

      if (document.documentElement.scrollTop > (scroll - 1) || document.body.scrollTop > (scroll - 1)) {
        el.classList.add(classReady)
      } else {
        el.classList.remove(classReady)
      }
      if (document.documentElement.scrollTop > scroll || document.body.scrollTop > scroll) {
        el.classList.add(classFixed)
        if(targetClass[i][1] != '') {
          const el_hide    = document.querySelector('.' + targetClass[i][1])
          const el_hideRect= el_hide.getBoundingClientRect()
          if(el_hideRect.y > el_hideRect.height){
            el.classList.add(classFixed)
          } else {
            el.classList.remove(classFixed)
          }
        }
      } else {
        el.classList.remove(classFixed)
      }
    })
  }
}

export {stickyContent as default}
